import * as React from 'react';
import { Divider } from 'wix-ui-tpa';
import { classes, st } from './SummeryDivider.st.css';
import { TotalsDataHook } from '../../Totals';
export var SummeryDivider = function (_a) {
    var className = _a.className;
    return (React.createElement(Divider, { className: st(classes.root, className), "data-hook": TotalsDataHook.SummaryDivider }));
};
SummeryDivider.displayName = 'Totals.SummeryDivider';
//# sourceMappingURL=SummeryDivider.js.map